// extracted by mini-css-extract-plugin
export default {"paButtonPrimary":"BBK2N9NAvO1z4w_0uCCR","paButtonSecondary":"zsqRyVKnN3yG5xQuVAi1"};